import BackendSettings from '../modules/siteSettings/components/backendSettings/components'
import ContactSetting from '../modules/siteSettings/components/contactSettings/ContactSetting'
import KeySettings from '../modules/siteSettings/components/keySetting/components'
import ModuleManager from '../modules/siteSettings/components/moduleManager/components/ModuleManager'
import Settings from '../modules/siteSettings/components/settings/components'
import SmtpSettings from '../modules/siteSettings/components/smtpSetting/components'
import Branches from '../modules/userMgmt/components/branch/components'
import Departments from '../modules/userMgmt/components/departments/components'
import RoleManagementIndex from '../modules/userMgmt/components/roles/components/RoleMgmt'
import UserRoleManagementIndex from '../modules/userMgmt/components/userRoles/UserRole'
import UserManagementIndex from '../modules/userMgmt/components/users/components/users'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

import {RouteComponentProps} from 'react-router-dom'
import {lazy} from 'react'

import ProductSchema from '../modules/masterData/onlineProductScheme'
import EmailTemplate from '../modules/cms/components/emailTemplate/components'

export interface RouteModel {
  path?: any
  component?: React.ComponentType<RouteComponentProps>
  exact?: boolean
}

export const RouteList = [
  {
    path: '/dashboard',
    component: DashboardWrapper,
    exact: true,
  },
  {
    path: '/cms/email-template',
    component: EmailTemplate,
    exact: true,
  },

  {
    path: '/usermanagement/users',
    component: UserManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/user-role',
    component: UserRoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/role',
    component: RoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/departments',
    component: Departments,
    exact: true,
  },
  {
    path: '/usermanagement/branch',
    component: Branches,
    exact: true,
  },
  {
    path: '/sitesetting/module',
    component: ModuleManager,
    exact: true,
  },
  {
    path: '/sitesetting/contact-setting',
    component: ContactSetting,
    exact: true,
  },
  {
    path: '/sitesetting/backend-setting',
    component: BackendSettings,
    exact: true,
  },
  {
    path: '/sitesetting/setting',
    component: Settings,
    exact: true,
  },
  {
    path: '/sitesetting/smtp-setting',
    component: SmtpSettings,
    exact: true,
  },
  {
    path: '/sitesetting/key-setting',
    component: KeySettings,
    exact: true,
  },

  // Products Schema
  {
    path: '/online-account-opening/product-schema',
    component: ProductSchema,
    exact: true,
  },

  // BPM Form
  {
    path: '/form-generator',
    component: lazy(async () => await import('../modules/laravelForm/generator/index')),
    exact: true,
  },
  {
    path: '/form-manager',
    component: lazy(async () => await import('../modules/laravelForm/manager/index')),
    exact: true,
  },

  // Customer Online Account
  {
    path: '/customer-online-account',
    component: lazy(
      async () => await import('../modules/customerOnlineAccount/customerOnlineAccounts')
    ),
    exact: true,
  },
  {
    path: '/customer-online-account/customer-account/final-review/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/customerOnlineAccount/customerOnlineAccounts/CustomerOnlineScreenPage'
        )
    ),
  },
  {
    path: '/preliminary-unverified',
    component: lazy(
      async () => await import('../modules/customerOnlineAccount/preliminary-unverified')
    ),
    exact: true,
  },

  // Quick Account Opening
  {
    path: '/quick-account-opening',
    component: lazy(async () => await import('../modules/quickAccountOpening')),
    exact: true,
  },
  {
    path: '/quick-account-opening/quick-account-opening-form',
    component: lazy(
      async () => await import('../modules/quickAccountOpening/quickAccountOpeningScreenPage')
    ),
    staticName: '',
    exact: true,
  },
  {
    path: '/quick-account-opening/quick-account-opening-form-completed/:case_id',
    component: lazy(async () => await import('../modules/quickAccountOpening/completedScreenPage')),
    staticName: '',
    exact: true,
  },
  {
    path: '/quick-account-opening/quick-account-opening-form/:case_id',
    component: lazy(
      async () => await import('../modules/quickAccountOpening/quickAccountOpeningScreenPage')
    ),
    staticName: '',
    exact: true,
  },

  // New Account Closure
  {
    path: '/account-closure',
    component: lazy(async () => await import('../modules/accountClosure')),
    exact: true,
  },
  {
    path: '/account-closure/account-closure-form',
    component: lazy(async () => await import('../modules/accountClosure/accountClosureScreenPage')),
    staticName: '',
    exact: true,
  },
  {
    path: '/account-closure/account-closure-form/:case_id',
    component: lazy(async () => await import('../modules/accountClosure/accountClosureScreenPage')),
    staticName: '',
    exact: true,
  },

  // New CIF New Account
  {
    path: '/new-cif-new-account',
    component: lazy(async () => await import('../modules/newCifNewAccount')),
    exact: true,
  },

  {
    path: '/new-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/rejectedList/accountRejectedList')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/account-opening-requests',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/Individual/finalForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/retail-review/:case_id',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/review/retailReviewForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/account-opening-status',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/account-status/AccountStatus'
        )
    ),
    staticName: 'Account Status',
    exact: true,
  },
  {
    path: '/accounts/account-closure',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/account-closure-report/AccountClosureReport'
        )
    ),
    staticName: 'Account Status',
    exact: true,
  },
  {
    path: '/accounts/ancillary-services',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/ancillaryServices/index')
    ),
    staticName: 'Ancillary Services',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/individualScreenForm/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/screening/individualJointMinorScreening/individualScreenPage'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/individualScreenForm',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/screening/individualJointMinorScreening/individualScreenPage'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/screening/corporateScreening/corporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/screening/corporateScreening/corporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/corporate/finalForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // New CIF Only
  {
    path: '/new-cif-only',
    component: lazy(async () => await import('../modules/newCIFOnly/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/OpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/individual-cif-form',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/NewCifOpenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/corporate-cif-form',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/CorporateCifScreenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/individual-cif-form/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/NewCifOpenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/corporate-cif-form/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/CorporateCifScreenPage')
    ),
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-corporate',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  //ENquiry Module

  // MASTER DATA
  {
    path: '/master-data/account-category',
    component: lazy(async () => await import('../modules/masterData/accountCategory')),
    exact: true,
  },
  {
    path: '/master-data/account-type',
    component: lazy(async () => await import('../modules/masterData/accountType')),
    exact: true,
  },
  {
    path: '/master-data/account-purposes',
    component: lazy(async () => await import('../modules/masterData/accountPurposes')),
    exact: true,
  },
  {
    path: '/master-data/branches',
    component: lazy(async () => await import('../modules/masterData/branches')),
    exact: true,
  },
  {
    path: '/master-data/business-type',
    component: lazy(async () => await import('../modules/masterData/businessType')),
    exact: true,
  },
  {
    path: '/master-data/constitution-codes',
    component: lazy(async () => await import('../modules/masterData/constitutionCodes')),
    exact: true,
  },
  {
    path: '/master-data/constitution-types',
    component: lazy(async () => await import('../modules/masterData/constitutionTypes')),
    exact: true,
  },
  {
    path: '/master-data/corporate-document-types',
    component: lazy(async () => await import('../modules/masterData/corporateDocumentTypes')),
    exact: true,
  },
  {
    path: '/master-data/corporate-relation',
    component: lazy(async () => await import('../modules/masterData/corporateRelation')),
    exact: true,
  },
  {
    path: '/master-data/corporate-relation-types',
    component: lazy(async () => await import('../modules/masterData/corporateRelationTypes')),
    exact: true,
  },
  {
    path: '/master-data/countries',
    component: lazy(async () => await import('../modules/masterData/countries')),
    exact: true,
  },
  {
    path: '/master-data/country-codes',
    component: lazy(async () => await import('../modules/masterData/countryCodes')),
    exact: true,
  },
  {
    path: '/master-data/currencies',
    component: lazy(async () => await import('../modules/masterData/currencies')),
    exact: true,
  },
  {
    path: '/master-data/customer-status',
    component: lazy(async () => await import('../modules/masterData/customerStatus')),
    exact: true,
  },
  {
    path: '/master-data/customer-type-relation',
    component: lazy(async () => await import('../modules/masterData/customerTypeRelation')),
    exact: true,
  },
  {
    path: '/master-data/customer-types',
    component: lazy(async () => await import('../modules/masterData/customerTypes')),
    exact: true,
  },
  {
    path: '/master-data/districts',
    component: lazy(async () => await import('../modules/masterData/districts')),
    exact: true,
  },
  {
    path: '/master-data/document-types',
    component: lazy(async () => await import('../modules/masterData/documentTypes')),
    exact: true,
  },
  {
    path: '/master-data/education-qualifications',
    component: lazy(async () => await import('../modules/masterData/educationQualifications')),
    exact: true,
  },
  {
    path: '/master-data/entity-classes',
    component: lazy(async () => await import('../modules/masterData/entityClasses')),
    exact: true,
  },
  {
    path: '/master-data/genders',
    component: lazy(async () => await import('../modules/masterData/genders')),
    exact: true,
  },
  {
    path: '/master-data/income-sources',
    component: lazy(async () => await import('../modules/masterData/incomeSources')),
    exact: true,
  },
  {
    path: '/master-data/issuing-authorities',
    component: lazy(async () => await import('../modules/masterData/issuingAuthorities')),
    exact: true,
  },
  {
    path: '/master-data/legal-entities',
    component: lazy(async () => await import('../modules/masterData/legalEntities')),
    exact: true,
  },
  {
    path: '/master-data/literacy',
    component: lazy(async () => await import('../modules/masterData/literacy')),
    exact: true,
  },
  {
    path: '/master-data/local-bodies',
    component: lazy(async () => await import('../modules/masterData/localBodies')),
    exact: true,
  },
  {
    path: '/master-data/marital-status',
    component: lazy(async () => await import('../modules/masterData/maritalStatus')),
    exact: true,
  },
  {
    path: '/master-data/nationalities',
    component: lazy(async () => await import('../modules/masterData/nationalities')),
    exact: true,
  },
  {
    path: '/master-data/occupations',
    component: lazy(async () => await import('../modules/masterData/occupations')),
    exact: true,
  },
  {
    path: '/master-data/occupations-types',
    component: lazy(async () => await import('../modules/masterData/occupationsTypes')),
    exact: true,
  },
  {
    path: '/master-data/provinces',
    component: lazy(async () => await import('../modules/masterData/provinces')),
    exact: true,
  },
  {
    path: '/master-data/relationships',
    component: lazy(async () => await import('../modules/masterData/relationships')),
    exact: true,
  },
  {
    path: '/master-data/salutations',
    component: lazy(async () => await import('../modules/masterData/salutations')),
    exact: true,
  },
  {
    path: '/master-data/scheme-type',
    component: lazy(async () => await import('../modules/masterData/schemeType')),
    exact: true,
  },
  {
    path: '/master-data/sectors',
    component: lazy(async () => await import('../modules/masterData/sectors')),
    exact: true,
  },
  {
    path: '/master-data/sub-sectors',
    component: lazy(async () => await import('../modules/masterData/subSectors')),
    exact: true,
  },
]
